// "Load more" footer for paginated lists. Lists in this SPA are
// forward-only — the backend's cursors don't support backwards
// traversal — so there's no previous-page UI to design around.

interface PaginationControlProps {
  loadedCount: number
  hasMore: boolean
  isFetchingMore: boolean
  onLoadMore: () => void
}

export function PaginationControl({
  loadedCount,
  hasMore,
  isFetchingMore,
  onLoadMore,
}: PaginationControlProps) {
  return (
    <div
      className="flex items-center justify-between border-t border-stone-200
                 bg-stone-50 px-4 py-2 text-xs text-stone-600"
    >
      <span>
        Showing {loadedCount} {loadedCount === 1 ? 'row' : 'rows'}
        {hasMore ? ' (more available)' : ''}
      </span>
      <button
        type="button"
        onClick={onLoadMore}
        disabled={!hasMore || isFetchingMore}
        className="rounded-md border border-stone-300 bg-white px-3 py-1
                   text-xs font-medium text-stone-700 shadow-sm
                   hover:bg-stone-50 disabled:cursor-not-allowed
                   disabled:opacity-50"
      >
        {isFetchingMore
          ? 'Loading…'
          : hasMore
            ? 'Load more'
            : 'No more rows'}
      </button>
    </div>
  )
}
